import React from 'react';
import { Issue } from '../models/Issue';
import { Box, Container, Typography, Button } from '@mui/material';

interface IssueComponentProps {
  issue: Issue;
  onAnswerSelect: (index: number) => Promise<void>;
}

const IssuePromptComponent: React.FC<IssueComponentProps> = ({ issue, onAnswerSelect }) => {
  const { outstandingQuestion } = issue;

  const selectOption = (index: number) => {
      onAnswerSelect(index);
  }

  return (
    <Container component="main" maxWidth="sm" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Box sx={{ mt: 4, width: '100%' }}>
        <Typography component="h1" variant="h5" gutterBottom>
          {outstandingQuestion.QuestionText}
        </Typography>
        <Box sx={{ mt: 2 }}>
          {outstandingQuestion.Options.map((option, index) => (
            <Button 
              key={index} 
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 5, py: 2, fontSize: '1.25rem' }} // Adjust padding and font size
              onClick={() => selectOption(index)}
            >
              {option}
            </Button>
          ))}
        </Box>
        {outstandingQuestion.NeedPicture && (
          <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
            A picture is needed to answer this question.
          </Typography>
        )}
      </Box>
    </Container>
  );
};

export default IssuePromptComponent;
